export const activitySuccessContent = ({ administered, activityType }: { administered: boolean, activityType?: 'drug' | 'questionnaire' | 'measurement' }) => {
    if (activityType === 'questionnaire') {
        return {
            title: "screens.activities.activityCompleted.title",
            description: "screens.activities.activityCompleted.description"
        }
    }
    
    if (activityType === 'measurement') {
        return {
            title: "screens.activities.activityCompleted.title",
            description: "screens.activities.activityCompleted.description"
        }
    }
    
    switch (administered) {
        case true:
            return {
                title: "screens.activities.drugsIntake.activityCompleted.title",
                description: "screens.activities.drugsIntake.activityCompleted.description"
            }
        case false:
            return {
                title: "screens.activities.drugsIntake.informationSentToDoctor",
            }
        default:
            return {
                title: "screens.activities.drugsIntake.activityCompleted.title",
                description: "screens.activities.drugsIntake.activityCompleted.description"

            }
    }
}